import { contentConstants } from '../_constants/content.constants'
import { contentService } from '../_services/content.service'



export const contentActions = {
  getContent,
  updateContent
}
function getContent() {
  return dispatch => {
    dispatch(request())
    contentService.getContent()
      .then(
        content => dispatch(success(content)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() { return { type: contentConstants.GET_REQUEST} }
  function success(content) { return { type: contentConstants.GET_SUCCESS, content } }
  function failure(error) { return { type: contentConstants.GET_ERROR, error } }
}
function updateContent(content) {
  return dispatch => {
    dispatch(request())
    contentService.updateContent(content)
      .then(
        content => dispatch(success(content)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() { return { type: contentConstants.PUT_REQUEST} }
  function success(content) { return { type: contentConstants.PUT_SUCCESS, content } }
  function failure(error) { return { type: contentConstants.PUT_ERROR, error } }
}

